import { T } from './theme';

const LessonSearch = ({ query, results, searching, onChange, onPick, isMobile }) => (
  <div style={{ position: 'relative', maxWidth: isMobile ? '100%' : 380 }}>
    <svg
      width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={T.faint} strokeWidth="2.2"
      strokeLinecap="round" aria-hidden="true"
      style={{ position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)' }}
    >
      <circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" />
    </svg>
    <input
      type="text"
      placeholder="Keresés a leckék között…"
      value={query}
      onChange={e => onChange(e.target.value)}
      aria-label="Keresés a leckék között"
      style={{
        width: '100%', height: 40, boxSizing: 'border-box',
        padding: '0 14px 0 36px',
        background: T.surface, border: `1px solid ${T.line}`,
        borderRadius: 10, color: T.text, fontSize: 14, outline: 'none',
        transition: 'border-color 0.15s, background 0.15s',
      }}
      onFocus={e => { e.target.style.borderColor = T.accentLine; e.target.style.background = T.surfaceHover; }}
      onBlur={e => { e.target.style.borderColor = T.line; e.target.style.background = T.surface; }}
    />

    {query.length >= 2 && (
      <div style={{
        position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 6, zIndex: 100,
        background: '#161a26', border: `1px solid ${T.line}`, borderRadius: 12,
        boxShadow: '0 18px 40px -12px rgba(0,0,0,0.6)',
        maxHeight: 380, overflowY: 'auto', minWidth: isMobile ? 0 : 420,
      }}>
        {searching && <div style={{ padding: 14, color: T.faint, fontSize: 13 }}>Keresés…</div>}
        {!searching && results.length === 0 && (
          <div style={{ padding: 14, color: T.faint, fontSize: 13 }}>Nincs találat</div>
        )}
        {!searching && results.map(r => (
          <div
            key={r.id}
            onClick={() => onPick(r.id)}
            style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: `1px solid ${T.line}` }}
            onMouseEnter={e => { e.currentTarget.style.background = T.surfaceHover; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
          >
            <div style={{ fontSize: 13, fontWeight: 600, color: T.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {r.title}
            </div>
            <div style={{ fontSize: 11, color: T.faint, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {r.modules?.courses?.title} · {r.modules?.title}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default LessonSearch;
